import React, { useEffect, useState } from "react";
import { Card } from 'primereact/card';
import FullscreenLayout from "@/Themes/Default/Layouts/FullscreenLayout";
import ForgotPasswordForm from "@/Components/Forms/ForgotPasswordForm";

/**
 * Forgot password page
 */
const ForgotPasswordPage = () => {
    useEffect(() => {
        document.title = 'Forgot password' + ' · ' + document.title;        
    }, []);

    return (
        <FullscreenLayout>
            <Card>                
                <ForgotPasswordForm />
            </Card>
        </FullscreenLayout>
    );
};

export default ForgotPasswordPage;